import { render } from "./NuevoLoteComponent.vue?vue&type=template&id=57607701&scoped=true"
import script from "./NuevoLoteComponent.vue?vue&type=script&lang=js"
export * from "./NuevoLoteComponent.vue?vue&type=script&lang=js"

import "./NuevoLoteComponent.vue?vue&type=style&index=0&id=57607701&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\eric.aparicio\\Documents\\REPOS\\ubiku.2023-master\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57607701"]])

export default __exports__